import { z } from 'zod';
import {
    CURRENT_SITUATION_EVALUATION_AUDIT_METHOD_OPTIONS,
    CURRENT_SITUATION_EVALUATION_AUDIT_METHODS,
    CURRENT_SITUATION_EVALUATION_CRITICALITY_LEVELS,
    CURRENT_SITUATION_EVALUATION_FINDING_TYPES,
    CURRENT_SITUATION_EVALUATION_MEASURE_EFFECTIVENESS_STATUSES,
    CURRENT_SITUATION_EVALUATION_MEASURE_IMPLEMENTATION_STATUSES,
} from './current-situation-evaluation.constants.js';

export const CurrentSituationMeasureEvaluationSchema = z.object({
    measureImplementationStatus: z.enum(CURRENT_SITUATION_EVALUATION_MEASURE_IMPLEMENTATION_STATUSES).nullable().optional(),
    measureEffectivenessStatus: z.enum(CURRENT_SITUATION_EVALUATION_MEASURE_EFFECTIVENESS_STATUSES).nullable().optional(),
    criticalityLevel: z.enum(CURRENT_SITUATION_EVALUATION_CRITICALITY_LEVELS).nullable().optional(),
    auditMethod: z.enum(CURRENT_SITUATION_EVALUATION_AUDIT_METHODS).nullable().optional(),
    findingType: z.enum(CURRENT_SITUATION_EVALUATION_FINDING_TYPES).nullable().optional(),
    auditMethods: z.array(z.enum(CURRENT_SITUATION_EVALUATION_AUDIT_METHOD_OPTIONS)).optional(),
    auditorComment: z.string().trim().max(5000).optional(),
});

export const UpdateCurrentSituationMeasureEvaluationSchema = z.object({
    measureImplementationStatus: z.enum(CURRENT_SITUATION_EVALUATION_MEASURE_IMPLEMENTATION_STATUSES),
    measureEffectivenessStatus: z.enum(CURRENT_SITUATION_EVALUATION_MEASURE_EFFECTIVENESS_STATUSES).nullable().optional(),
    criticalityLevel: z.enum(CURRENT_SITUATION_EVALUATION_CRITICALITY_LEVELS).nullable().optional(),
    auditMethod: z.enum(CURRENT_SITUATION_EVALUATION_AUDIT_METHODS).nullable().optional(),
    findingType: z.enum(CURRENT_SITUATION_EVALUATION_FINDING_TYPES).nullable().optional(),
    auditMethods: z.array(z.enum(CURRENT_SITUATION_EVALUATION_AUDIT_METHOD_OPTIONS)).optional().default([]),
    auditorComment: z.string().trim().max(5000).optional().default(''),
});

export const UpdateBigdesCurrentSituationEvaluationScopeSchema = z.object({
    applicabilityIds: z.array(z.string().min(1)).min(1, 'En az bir varlık grubu seçilmelidir'),
});
